import {
    Component,
    EventEmitter,
    forwardRef,
    Host,
    OnInit,
    Optional,
    Output,
    SkipSelf,
    ViewEncapsulation
} from '@angular/core';

import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';

import {MatSelectChange} from '@angular/material/select';

import * as moment from 'moment';

import {ComponentTypesEnum} from '../../enums';
import {SelectComponent} from '../../components';
import {AddNewSelectControl} from '../../classes';

@Component({
    selector: 'app-add-new-select',
    templateUrl: './add-new-select.component.html',
    styleUrls: ['./add-new-select.component.scss'],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => AddNewSelectComponent),
        multi: true
    }],
    encapsulation: ViewEncapsulation.None
})
export class AddNewSelectComponent extends SelectComponent implements OnInit {
    public isAddNewSelected: boolean;

    constructor(
        @Optional() @Host() @SkipSelf()
        protected controlContainer: ControlContainer
    ) {
        super(controlContainer);

        this.isAddNewSelected = false;
    }

    ngOnInit() {
        super.ngOnInit();
    }

    changeValue(event: MatSelectChange): void {
        this.isAddNewSelected = typeof event.value === 'boolean';

        super.changeValue(event);
    }

    public writeValue(value: number | string | boolean | number[] | string[]): void {
        super.writeValue(value);

        if (value === true) {
            this.isAddNewSelected = true;
        }
    }

    asFormsControl(): AddNewSelectControl {
        if (!this.control || !(this.control instanceof AddNewSelectControl)) {
            this.control = new AddNewSelectControl({
                name: '',
                value: '',
                placeholder: '',
                validators: [],
                componentType: ComponentTypesEnum.AddNewSelect,
                invalid: false,
                errors: [],
                options: [],
                addNewText: '',
                disableAddNew: false
            });
        }

        return (this.control as AddNewSelectControl);
    }
}
